export enum BlendEquationSeparate{
    ADD,//source + destination (default value)
    SUBTRACT,// source - destination
    REVERSE_SUBTRACT,//destination - source
    //TODO:
    MIN,//Minimum of source and destination
    MAX,//Maximum of source and destination
}